import { render, staticRenderFns } from "./GenerateInvoicesTab.vue?vue&type=template&id=1125df24&scoped=true"
import script from "./GenerateInvoicesTab.vue?vue&type=script&lang=js"
export * from "./GenerateInvoicesTab.vue?vue&type=script&lang=js"
import style0 from "./GenerateInvoicesTab.vue?vue&type=style&index=0&id=1125df24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1125df24",
  null
  
)

export default component.exports